var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: `content-carousel ${_vm.carouselClasses}` },
    [
      _vm.loading
        ? [
            _c(
              "ACarousel",
              {
                attrs: {
                  options: _vm.carouselOptions,
                  "place-arrows-outside": "",
                  "place-pagination-outside": "",
                },
              },
              [
                _vm._l(3, function (n) {
                  return _c(
                    "ACarouselSlide",
                    {
                      key: n,
                      staticClass: "content-carousel-slide",
                      attrs: {
                        index: n,
                        "ssr-number": _vm.ssrSlideNumber,
                        "ssr-margin": _vm.ssrSlideMargin,
                      },
                    },
                    [_vm._t("default", null, { item: {} })],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "swiper-pagination",
                  attrs: { slot: "pagination" },
                  slot: "pagination",
                }),
              ],
              2
            ),
          ]
        : _vm.items.length > 0
        ? [
            _c(
              "ACarousel",
              {
                attrs: {
                  options: _vm.carouselOptions,
                  "place-arrows-outside": "",
                  "place-pagination-outside": "",
                },
              },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "ACarouselSlide",
                  {
                    key: item.id,
                    staticClass: "content-carousel-slide",
                    attrs: {
                      index: index,
                      "ssr-number": _vm.ssrSlideNumber,
                      "ssr-margin": _vm.ssrSlideMargin,
                      "data-cy": `content-carousel-slide-${index}`,
                    },
                  },
                  [_vm._t("default", null, { item: item })],
                  2
                )
              }),
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }